/** contient tous les markers que l'on peut ajouter une map */
export const markers = {
    VALIDATION: {
        URL: Theme.themeURL + '/assets/dist/images/markers/validation.png',
        NAME: 'marker-validation',
        ICON: 'validation',
        SIZE: 0.3,
    },
    REGISTRATION: {
        URL: Theme.themeURL + '/assets/dist/images/markers/registration.png',
        NAME: 'marker-registration',
        ICON: 'compte',
        SIZE: 0.3,
    },
    ORDER: {
        URL: Theme.themeURL + '/assets/dist/images/markers/order.png',
        NAME: 'marker-order',
        SIZE: 0.3,
        ICON: 'achat',
    },
    SMSTICKET: {
        URL: Theme.themeURL + '/assets/dist/images/markers/validation.png',
        NAME: 'marker-smsticket',
        SIZE: 0.3,
        ICON: 'ticketsms',
    },
    ITINERARY: {
        URL: Theme.themeURL + '/assets/dist/images/markers/validation.png',
        NAME: 'marker-itinerary',
        SIZE: 0.3,
        ICON: 'itinerary',
    },
    TRANSFER: {
        URL: Theme.themeURL + '/assets/dist/images/markers/validation.png',
        NAME: 'marker-transfer',
        SIZE: 0.3,
        ICON: 'transfert',
    },

    AGGLO: {
        URL: Theme.themeURL + '/assets/dist/images/markers/marker-agglos.png',
        NAME: 'marker-white',
        SIZE: 0.15,
    },
    USERPOSITION: {
        URL: Theme.themeURL + '/assets/dist/images/markers/user-position.png',
        NAME: 'marker-user-position',
        SIZE: 0.4,
    },
}
